import { render, staticRenderFns } from "./LocalityDetail.vue?vue&type=template&id=58076852&"
import script from "./LocalityDetail.vue?vue&type=script&lang=js&"
export * from "./LocalityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports